import type { LimitFields, TimeLimit, SelfExclusion } from '@/types';
import { useLimitsStore } from '@/stores';
import { useToast } from 'primevue/usetoast';
import { useTimer } from './useTimer';
import { ref } from 'vue';
export function useLimits() {
    const limitsStore = useLimitsStore();
    const toast = useToast();
    const loadingFlag = ref<boolean>(false);
    const toastText = 'set_limit';
    const toastLimitDetail = 'set_limit_detail';
    const toastTimeText = 'set_time_limit';
    const toastTimeSetLimitDetail = 'set_time_limit_detail';
    const toastTimeUnsetLimitDetail = 'set_time_limit_unset_detail';
    const toastSelfExclusionText = 'set_self_exclusion';
    const toastSelfExclusionSetLimitDetail = 'set_self_exclusion_detail';
    async function toSetLimit(data: LimitFields, isDelete: boolean = false): Promise<void> {
        loadingFlag.value = true;
        try {
            await limitsStore.awaitSetLimit(data, isDelete);
            toast.add({ severity: 'success', group: 'global', summary: toastText, detail: toastLimitDetail, life: 4000 });
        } catch (error) {
            toast.add({ severity: 'error', group: 'global', summary: toastText, detail: error, life: 4000 });
        } finally {
            loadingFlag.value = false;
        }
    }
    async function toSetTimeLimit(data: TimeLimit): Promise<void> {
        loadingFlag.value = true;
        try {
            await limitsStore.awaitSetTimeLimit(data);
            const timer = useTimer(data.time_limit);
            if (data.time_limit) {
                timer.stopTimer();
                timer.startTimer();
                toast.add({ severity: 'success', group: 'global', summary: toastTimeText, detail: toastTimeSetLimitDetail, life: 4000 });
            } else {
                timer.stopTimer();
                toast.add({ severity: 'success', group: 'global', summary: toastTimeText, detail: toastTimeUnsetLimitDetail, life: 4000 });
            }
        } catch (error) {
            toast.add({ severity: 'error', group: 'global', summary: toastTimeText, detail: error, life: 4000 });
        } finally {
            loadingFlag.value = false;
        }
    }
    async function toSetSelfExclusion(data: SelfExclusion): Promise<void> {
        loadingFlag.value = true;
        try {
            await limitsStore.awaitSetSelfExclusion(data);
            toast.add({ severity: 'success', group: 'global', summary: toastSelfExclusionText, detail: toastSelfExclusionSetLimitDetail, life: 4000 });
        } catch (error) {
            toast.add({ severity: 'error', group: 'global', summary: toastSelfExclusionText, detail: error, life: 4000 });
        } finally {
            loadingFlag.value = false;
        }
    }
    return {
        loadingFlag,
        toSetLimit,
        toSetTimeLimit,
        toSetSelfExclusion
    };
}
